import _ from 'lodash';
import { orderObjectBy } from 'Utils/filters';
import tanksTemplate from './tanks.html';
import hauledTemplate from '../hauled-away.html';


export default {
  name: 'productionTanks',
  template: tanksTemplate,
  controller: TanksController,
  controllerAs: 'ProductionTanksCtrl',
  bindings: {
    options: '<',
    queryParams: '<'
  }
};

/* @ngInject */
function TanksController(
  $uibModal,
  $log,
  ReportsService,
  EquipmentInfoService,
  ModalService
) {
  const vm = this;

  vm.listOfTanks = [];
  vm.listOfTanksOptions = {};

  vm.modalInstance = null;
  vm.arrageByCumulative = false;
  vm.cumulativeData = null;
  vm.isSaving = false;

  vm.$onInit = initialize;
  vm.generateProductionReport = generateProductionReport;
  vm.hauledAway = hauledAway;
  vm.tanksEmpty = tanksEmpty;
  vm.reportEmpty = reportEmpty;
  vm.sortFn = sortFn;
  vm.setToIndividual = setToIndividual;
  vm.setToCumulative = setToCumulative;
  vm.openCopyReportLink = ModalService.openCopyReportLink;
  vm.invalidDate = ReportsService.invalidDate;
  vm.lengthOf = ReportsService.lengthOf;
  vm.deepLink = ReportsService.deepLink;
  vm.exportData = ReportsService.exportData;

  function initialize() {
    vm.listOfTanks = [];

    return loadTanks();
  }

  function generateProductionReport() {
    vm.isLoading = true;
    let tankIds = vm.options.tanks;
    if (_.isObject(tankIds[0])) {
      tankIds = _.map(vm.options.tanks, 'id');
    }

    return ReportsService.getProductionReportData(
      tankIds,
      vm.options.date.start.valueOf(),
      vm.options.date.end.valueOf()
    ).then((success) => {
      if (_.has(success, ['data', 'cumulative']) && _.has(success, ['data', 'individualEquipment'])) {
        vm.cumulativeData = success.data.cumulative;
        vm.productionReportDatas = success.data.individualEquipment;
        vm.orderedProdReportData = orderObjectBy(vm.productionReportData, 'name');

        const equipmentIds = _.keys(vm.productionReportDatas);
        EquipmentInfoService.getEquipmentById(equipmentIds)
          .then((eqs) => {
            eqs = _.keyBy(eqs, 'id');
            _.forEach(vm.productionReportDatas, (dat) => {
              const id = dat.id;
              dat.name = _.has(eqs, [id, 'name']) ?
                eqs[id].name : 'no name';
            });
          });
      } else {
        $log.error('Unexpected server data:', success);
      }
      vm.isLoading = false;
      checkIfExportEnabled();
    });
  }

  function loadTanks() {
    return ReportsService.getListOfTanks()
      .then((success) => {
        vm.listOfTanks = success;
        if (vm.queryParams.start) {
          vm.options.date.start = new Date(Number(vm.queryParams.start));
        }
        if (vm.queryParams.end) {
          vm.options.date.end = new Date(Number(vm.queryParams.end));
        }
        if (vm.queryParams.tanks) {
          vm.options.tanks = _.map(vm.queryParams.tanks.split('|'), id => _.find(vm.listOfTanks, ['id', id]));
          generateProductionReport();
        }
      });
  }

  function tanksEmpty() {
    return vm.options.tanks && vm.options.tanks.length > 0;
  }

  function hauledAway(productionReportData) {
    const equipmentId = vm.options.tanks[0];
    vm.modalInstance = $uibModal.open({
      template: hauledTemplate,
      size: 'sm',
      controllerAs: 'HauledCtrl',
      controller: 'HauledModalController',
      resolve: {
        prodDate: () => new Date(productionReportData.cutoffDate)
      }
    });
    vm.modalInstance.result
      .then(([waterDelta, oilDelta]) => {
        if (vm.isSaving) {
          return null;
        }
        vm.isSaving = true;
        if (equipmentId && productionReportData.cutoffDate) {
          const haulAwayEvent = {
            equipment: equipmentId,
            cutoffDate: productionReportData.cutoffDate,
            water: waterDelta,
            oil: oilDelta
          };
          return ReportsService.saveHaulAway(haulAwayEvent)
            .then(() => {
              vm.isSaving = false;
              return vm.generateProductionReport();
            }, () => {
              // growl failed to save
              vm.isSaving = false;
            });
        }
        return null;
      })
      .catch(() => { /* */ });
  }

  function sortFn(object) {
    return object.name.toLowerCase();
  }

  function setToIndividual() {
    vm.arrageByCumulative = false;
    checkIfExportEnabled();
  }

  function setToCumulative() {
    vm.arrageByCumulative = true;
    checkIfExportEnabled();
  }

  function checkIfExportEnabled() {
    vm.enableExport = vm.arrageByCumulative ?
      !_.isEmpty(vm.cumulativeData) : !_.isEmpty(vm.productionReportDatas);
  }

  function reportEmpty() {
    return !((vm.arrageByCumulative && !_.isEmpty(vm.cumulativeData)) ||
        (!vm.arrageByCumulative && !_.isEmpty(vm.productionReportDatas)));
  }
}
